export type SharedChatError = {
  statusCode: number;
  title: string;
  message: string[];
};

export enum SharedChatType {
  Chat = 'chat',
  Arena = 'arena',
}
